import { render } from "./GetPincodesHistory.vue?vue&type=template&id=7463874f"
import script from "./GetPincodesHistory.vue?vue&type=script&lang=js"
export * from "./GetPincodesHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__